var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetpointCzuwanie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "42.3333mm",
    height: "42.3334mm",
    viewBox: "0 0 4860.53 4860.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#009245",
    d: "M4860.53 2160.11l0 2397.17c0,167.13 -135.72,303.26 -302.8,303.26l-4253.63 0c-167.93,0 -304.1,-136.14 -304.1,-303.26l0 -2397.17c0,-85.92 40.38,-167.53 115.11,-229.78l2087.08 -1817.36c1.7,-1.7 3.85,-3.85 5.58,-5.58 58,-64.41 147.32,-107.39 222.5,-107.39 95.34,0 176.1,30.1 221.64,82.07 2.14,2.15 4.28,4.29 5.99,5.99l2129.6 1864.59c18.46,21.06 34.39,49.41 46.82,84.21l1.3 3.85c0.4,2.59 1.29,4.74 1.7,6.89 8.17,26.6 12.47,46.82 13.32,65.28 0,4.71 0.85,9.44 2.15,13.73l2.59 9.44c2.55,9.44 5.14,18.07 5.14,24.07z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetpointCzuwanie);
export default __webpack_public_path__ + "static/media/setpoint-czuwanie.77e05bc6cdcb337f875a787c6358105f.svg";
export { ForwardRef as ReactComponent };